export default "__VITE_ASSET__c27f8597__"